//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Geeft de gegevens van Form Adviesonderwerpen
     * @param vestigingId (optional) Als de gegevens van een vestiging opgehaald worden, bepaalt dit id van welke vestiging
     * @return Success
     */
    adviesonderwerpen_ophalen(vestigingId: string | null | undefined): Promise<AdviesonderwerpenOutput> {
        let url_ = this.baseUrl + "/Adviesonderwerpen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdviesonderwerpen_ophalen(_response);
        });
    }

    protected processAdviesonderwerpen_ophalen(response: Response): Promise<AdviesonderwerpenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesonderwerpenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesonderwerpenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdviesonderwerpenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdviesonderwerpenOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Adviesonderwerpen
     * @param vestigingId (optional) Als de gegevens van een vestiging opgehaald worden, bepaalt dit id van welke vestiging
     * @param body (optional) adviesonderwerpen model
     * @return No Content
     */
    adviesonderwerpen_wijzigen(vestigingId: string | null | undefined, body: Adviesonderwerpen | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Adviesonderwerpen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdviesonderwerpen_wijzigen(_response);
        });
    }

    protected processAdviesonderwerpen_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de inhoud van het Adviesbox-form Autorisatieniveau.
     * @param vestigingId De identificatie van de vestiging
     * @return Success
     */
    autorisatieniveau_ophalen(vestigingId: string): Promise<AutorisatieniveauOutput> {
        let url_ = this.baseUrl + "/Autorisatieniveau";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutorisatieniveau_ophalen(_response);
        });
    }

    protected processAutorisatieniveau_ophalen(response: Response): Promise<AutorisatieniveauOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutorisatieniveauOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutorisatieniveauOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutorisatieniveauOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het Adviesbox-form Autorisatieniveau .
     * @param vestigingId De identificatie van de vestiging
     * @param body (optional) De inhoud van het Adviesbox-form Autorisatieniveau
     * @return No Content
     */
    autorisatieniveau_wijzigen(vestigingId: string, body: Autorisatieniveau | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Autorisatieniveau";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutorisatieniveau_wijzigen(_response);
        });
    }

    protected processAutorisatieniveau_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Beheer partijen - Bank / Vermogensbeheerders
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @return Success
     */
    vermogensbeheerders_ophalen(vestigingId: string | null | undefined): Promise<VermogensbeheerdersOutput> {
        let url_ = this.baseUrl + "/BeheerPartijen/Vermogensbeheerders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogensbeheerders_ophalen(_response);
        });
    }

    protected processVermogensbeheerders_ophalen(response: Response): Promise<VermogensbeheerdersOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensbeheerdersOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensbeheerdersOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VermogensbeheerdersOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VermogensbeheerdersOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Beheer partijen - Bank / Vermogensbeheerders
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @param body (optional) De inhoud van het Adviesbox-form Bank / Vermogensbeheerders
     * @return No Content
     */
    vermogensbeheerders_wijzigen(vestigingId: string | null | undefined, body: Vermogensbeheerders | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/BeheerPartijen/Vermogensbeheerders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVermogensbeheerders_wijzigen(_response);
        });
    }

    protected processVermogensbeheerders_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Beheer partijen - Bankgarantieinstellingen
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @return Success
     */
    bankgarantieinstellingen_ophalen(vestigingId: string | null | undefined): Promise<BankgarantieinstellingenOutput> {
        let url_ = this.baseUrl + "/BeheerPartijen/Bankgarantieinstellingen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBankgarantieinstellingen_ophalen(_response);
        });
    }

    protected processBankgarantieinstellingen_ophalen(response: Response): Promise<BankgarantieinstellingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankgarantieinstellingenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankgarantieinstellingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankgarantieinstellingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankgarantieinstellingenOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Beheer partijen - Bankgarantieinstellingen
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @param body (optional) De inhoud van het Adviesbox-form Bankgarantieinstellingen
     * @return No Content
     */
    bankgarantieinstellingen_wijzigen(vestigingId: string | null | undefined, body: Bankgarantieinstellingen | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/BeheerPartijen/Bankgarantieinstellingen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBankgarantieinstellingen_wijzigen(_response);
        });
    }

    protected processBankgarantieinstellingen_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Beheer partijen - Geldverstrekkers
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @return Success
     */
    geldverstrekkers_ophalen(vestigingId: string | null | undefined): Promise<GeldverstrekkersOutput> {
        let url_ = this.baseUrl + "/BeheerPartijen/Geldverstrekkers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeldverstrekkers_ophalen(_response);
        });
    }

    protected processGeldverstrekkers_ophalen(response: Response): Promise<GeldverstrekkersOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeldverstrekkersOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeldverstrekkersOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GeldverstrekkersOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GeldverstrekkersOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Beheer partijen - Geldverstrekkers
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @param body (optional) De inhoud van het Adviesbox-form Geldverstrekkers
     * @return No Content
     */
    geldverstrekkers_wijzigen(vestigingId: string | null | undefined, body: Geldverstrekkers | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/BeheerPartijen/Geldverstrekkers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeldverstrekkers_wijzigen(_response);
        });
    }

    protected processGeldverstrekkers_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Beheer partijen - Notarissen
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @return Success
     */
    notarissen_ophalen(vestigingId: string | null | undefined): Promise<NotarissenOutput> {
        let url_ = this.baseUrl + "/BeheerPartijen/Notarissen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNotarissen_ophalen(_response);
        });
    }

    protected processNotarissen_ophalen(response: Response): Promise<NotarissenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotarissenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotarissenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotarissenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotarissenOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Beheer partijen - Notarissen
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @param body (optional) De inhoud van het Adviesbox-form Notarissen
     * @return No Content
     */
    notarissen_wijzigen(vestigingId: string | null | undefined, body: Notarissen | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/BeheerPartijen/Notarissen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNotarissen_wijzigen(_response);
        });
    }

    protected processNotarissen_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Beheer partijen - Serviceproviders
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @return Success
     */
    serviceproviders_ophalen(vestigingId: string | null | undefined): Promise<ServiceprovidersOutput> {
        let url_ = this.baseUrl + "/BeheerPartijen/Serviceproviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServiceproviders_ophalen(_response);
        });
    }

    protected processServiceproviders_ophalen(response: Response): Promise<ServiceprovidersOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceprovidersOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceprovidersOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ServiceprovidersOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceprovidersOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Beheer partijen - Serviceproviders
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @param body (optional) De inhoud van het Adviesbox-form Serviceproviders
     * @return No Content
     */
    serviceproviders_wijzigen(vestigingId: string | null | undefined, body: Serviceproviders | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/BeheerPartijen/Serviceproviders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServiceproviders_wijzigen(_response);
        });
    }

    protected processServiceproviders_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Beheer partijen - Software koppelingen
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @return Success
     */
    software_koppelingen_ophalen(vestigingId: string | null | undefined): Promise<SoftwareKoppelingenOutput> {
        let url_ = this.baseUrl + "/BeheerPartijen/SoftwareKoppelingen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSoftware_koppelingen_ophalen(_response);
        });
    }

    protected processSoftware_koppelingen_ophalen(response: Response): Promise<SoftwareKoppelingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SoftwareKoppelingenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SoftwareKoppelingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SoftwareKoppelingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SoftwareKoppelingenOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Beheer partijen - Software koppelingen
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @param body (optional) De inhoud van het Adviesbox-form Software koppelingen
     * @return No Content
     */
    software_koppelingen_wijzigen(vestigingId: string | null | undefined, body: SoftwareKoppelingen | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/BeheerPartijen/SoftwareKoppelingen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSoftware_koppelingen_wijzigen(_response);
        });
    }

    protected processSoftware_koppelingen_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Beheer partijen - Taxatiebureaus
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @return Success
     */
    taxatiebureaus_ophalen(vestigingId: string | null | undefined): Promise<TaxatiebureausOutput> {
        let url_ = this.baseUrl + "/BeheerPartijen/Taxatiebureaus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTaxatiebureaus_ophalen(_response);
        });
    }

    protected processTaxatiebureaus_ophalen(response: Response): Promise<TaxatiebureausOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatiebureausOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatiebureausOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TaxatiebureausOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxatiebureausOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Beheer partijen - Taxatiebureaus
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @param body (optional) De inhoud van het Adviesbox-form Taxatiebureaus
     * @return No Content
     */
    taxatiebureaus_wijzigen(vestigingId: string | null | undefined, body: Taxatiebureaus | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/BeheerPartijen/Taxatiebureaus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTaxatiebureaus_wijzigen(_response);
        });
    }

    protected processTaxatiebureaus_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Beheer partijen - Verzekeraars
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @return Success
     */
    verzekeraars_ophalen(vestigingId: string | null | undefined): Promise<VerzekeraarsOutput> {
        let url_ = this.baseUrl + "/BeheerPartijen/Verzekeraars";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerzekeraars_ophalen(_response);
        });
    }

    protected processVerzekeraars_ophalen(response: Response): Promise<VerzekeraarsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VerzekeraarsOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VerzekeraarsOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VerzekeraarsOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerzekeraarsOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Beheer partijen - Verzekeraars
     * @param vestigingId (optional) De identificatie van de vestiging (verplicht indien de betreffende instellingen per vestiging worden onderhouden)
     * @param body (optional) De inhoud van het Adviesbox-form Verzekeraars
     * @return No Content
     */
    verzekeraars_wijzigen(vestigingId: string | null | undefined, body: Verzekeraars | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/BeheerPartijen/Verzekeraars";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerzekeraars_wijzigen(_response);
        });
    }

    protected processVerzekeraars_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Voorkeuren/Berekeningen
     * @param vestigingId (optional) Als de gegevens van een vestiging opgehaald worden, bepaalt dit id van welke vestiging
     * @return Success
     */
    berekeningen_ophalen(vestigingId: string | null | undefined): Promise<BerekeningenOutput> {
        let url_ = this.baseUrl + "/Berekeningen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBerekeningen_ophalen(_response);
        });
    }

    protected processBerekeningen_ophalen(response: Response): Promise<BerekeningenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BerekeningenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BerekeningenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BerekeningenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BerekeningenOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Voorkeuren/Berekeningen
     * @param vestigingId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    berekeningen_wijzigen(vestigingId: string | null | undefined, body: Berekeningen | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Berekeningen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBerekeningen_wijzigen(_response);
        });
    }

    protected processBerekeningen_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Voorkeuren/Documenten
     * @param vestigingId (optional) Als de gegevens van een vestiging opgehaald worden, bepaalt dit id van welke vestiging
     * @return Success
     */
    documenten_ophalen(vestigingId: string | null | undefined): Promise<DocumentenOutput> {
        let url_ = this.baseUrl + "/Documenten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumenten_ophalen(_response);
        });
    }

    protected processDocumenten_ophalen(response: Response): Promise<DocumentenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentenOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Voorkeuren/Documenten
     * @param vestigingId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    documenten_wijzigen(vestigingId: string | null | undefined, body: Documenten | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Documenten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumenten_wijzigen(_response);
        });
    }

    protected processDocumenten_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Importeert een voorblad afbeelding en werk hiermee de documenten-instellingen bij
     * @return Created
     */
    afbeelding_voorblad_importeren(vestigingId: string, voorbladAfbeeldingBestand: FileParameter): Promise<void> {
        let url_ = this.baseUrl + "/Documenten/VoorbladAfbeelding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (voorbladAfbeeldingBestand === null || voorbladAfbeeldingBestand === undefined)
            throw new Error("The parameter 'voorbladAfbeeldingBestand' cannot be null.");
        else
            content_.append("voorbladAfbeeldingBestand", voorbladAfbeeldingBestand.data, voorbladAfbeeldingBestand.fileName ? voorbladAfbeeldingBestand.fileName : "voorbladAfbeeldingBestand");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAfbeelding_voorblad_importeren(_response);
        });
    }

    protected processAfbeelding_voorblad_importeren(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de URL van de ingestelde voorblad-afbeelding.
     * @param vestigingId De identificatie van de vestiging
     * @return Success
     */
    afbeelding_voorblad_ophalen(vestigingId: string): Promise<VoorbladAfbeeldingOutput> {
        let url_ = this.baseUrl + "/Documenten/VoorbladAfbeelding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAfbeelding_voorblad_ophalen(_response);
        });
    }

    protected processAfbeelding_voorblad_ophalen(response: Response): Promise<VoorbladAfbeeldingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoorbladAfbeeldingOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoorbladAfbeeldingOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoorbladAfbeeldingOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoorbladAfbeeldingOutput>(null as any);
    }

    /**
     * Verwijdert de voorblad afbeelding van de betreffende vestiging.
     * @param vestigingId De identificatie van de vestiging
     * @return No Content
     */
    afbeelding_voorblad_verwijderen(vestigingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Documenten/VoorbladAfbeelding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAfbeelding_voorblad_verwijderen(_response);
        });
    }

    protected processAfbeelding_voorblad_verwijderen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft het token voor Nationale Waarborg
     * @param vestigingId (optional) 
     * @return Success
     */
    token_Nationale_Waarborg_ophalen(vestigingId: string | null | undefined): Promise<TokenOutput> {
        let url_ = this.baseUrl + "/ExterneKoppelingen/NationaleWaarborg";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToken_Nationale_Waarborg_ophalen(_response);
        });
    }

    protected processToken_Nationale_Waarborg_ophalen(response: Response): Promise<TokenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenOutput>(null as any);
    }

    /**
     * Verwerkt de het token voor Nationale Waarborg
     * @param vestigingId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    token_Nationale_Waarborg_wijzigen(vestigingId: string | null | undefined, body: Tokens | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ExterneKoppelingen/NationaleWaarborg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToken_Nationale_Waarborg_wijzigen(_response);
        });
    }

    protected processToken_Nationale_Waarborg_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft het token voor Nationale Waarborg
     * @param vestigingId (optional) 
     * @return Success
     */
    opvragen_of_Token_Nationale_Waarborg_actief_is(vestigingId: string | null | undefined): Promise<ActiefOutput> {
        let url_ = this.baseUrl + "/ExterneKoppelingen/NationaleWaarborg/Actief";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOpvragen_of_Token_Nationale_Waarborg_actief_is(_response);
        });
    }

    protected processOpvragen_of_Token_Nationale_Waarborg_actief_is(response: Response): Promise<ActiefOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActiefOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActiefOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActiefOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActiefOutput>(null as any);
    }

    /**
     * Geeft de gegevens voor de koppeling met Elements
     * @param vestigingId (optional) 
     * @return Success
     */
    koppeling_Elements_opvragen(vestigingId: string | null | undefined): Promise<ElementsOutput> {
        let url_ = this.baseUrl + "/ExterneKoppelingen/Elements";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKoppeling_Elements_opvragen(_response);
        });
    }

    protected processKoppeling_Elements_opvragen(response: Response): Promise<ElementsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ElementsOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ElementsOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ElementsOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ElementsOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens voor de koppeling met Elements
     * @param vestigingId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    koppeling_Elements_wijzigen(vestigingId: string | null | undefined, body: Elements | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ExterneKoppelingen/Elements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKoppeling_Elements_wijzigen(_response);
        });
    }

    protected processKoppeling_Elements_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van een importkoppeling
     * @param vestigingId (optional) Identificatie van de vestiging
     * @param softwareKoppelingId Identificatie van de software koppeling van de importkoppeling
     * @return Success
     */
    importkoppeling_opvragen(vestigingId: string | null | undefined, softwareKoppelingId: string): Promise<ImportkoppelingOutput> {
        let url_ = this.baseUrl + "/ExterneKoppelingen/Importkoppelingen/{softwareKoppelingId}";
        if (softwareKoppelingId === undefined || softwareKoppelingId === null)
            throw new Error("The parameter 'softwareKoppelingId' must be defined.");
        url_ = url_.replace("{softwareKoppelingId}", encodeURIComponent("" + softwareKoppelingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportkoppeling_opvragen(_response);
        });
    }

    protected processImportkoppeling_opvragen(response: Response): Promise<ImportkoppelingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportkoppelingOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens voor de importkoppeling met de gegeven naam
     * @param vestigingId (optional) Identificatie van de vestiging
     * @param softwareKoppelingId Identificatie van de software koppeling van de importkoppeling
     * @param body (optional) Gegevens van de importkoppeling
     * @return No Content
     */
    importkoppeling_wijzigen(vestigingId: string | null | undefined, softwareKoppelingId: string, body: Importkoppeling | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ExterneKoppelingen/Importkoppelingen/{softwareKoppelingId}";
        if (softwareKoppelingId === undefined || softwareKoppelingId === null)
            throw new Error("The parameter 'softwareKoppelingId' must be defined.");
        url_ = url_.replace("{softwareKoppelingId}", encodeURIComponent("" + softwareKoppelingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportkoppeling_wijzigen(_response);
        });
    }

    protected processImportkoppeling_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van een importkoppeling o.b.v. de koppeling key
     * @param koppelingKey Koppeling key van de importkoppeling
     * @return Success
     */
    importkoppeling_opvragen_via_koppelingKey(koppelingKey: string): Promise<ImportkoppelingOutput> {
        let url_ = this.baseUrl + "/ExterneKoppelingen/Importkoppelingen/KoppelingKeys/{koppelingKey}";
        if (koppelingKey === undefined || koppelingKey === null)
            throw new Error("The parameter 'koppelingKey' must be defined.");
        url_ = url_.replace("{koppelingKey}", encodeURIComponent("" + koppelingKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportkoppeling_opvragen_via_koppelingKey(_response);
        });
    }

    protected processImportkoppeling_opvragen_via_koppelingKey(response: Response): Promise<ImportkoppelingOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportkoppelingOutput>(null as any);
    }

    /**
     * Geeft alle importkoppelingen o.b.v. de huidige gebruiker
     * @param vestigingId (optional) Identificatie van de vestiging
     * @return Success
     */
    importkoppelingen_opvragen_voor_gebruiker(vestigingId: string | null | undefined): Promise<ImportkoppelingenOutput> {
        let url_ = this.baseUrl + "/ExterneKoppelingen/Importkoppelingen/KoppelingKeys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportkoppelingen_opvragen_voor_gebruiker(_response);
        });
    }

    protected processImportkoppelingen_opvragen_voor_gebruiker(response: Response): Promise<ImportkoppelingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportkoppelingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportkoppelingenOutput>(null as any);
    }

    /**
     * Geeft de gegevens van Form Klantprofiel en motivering
     * @param vestigingId (optional) Als de gegevens van een vestiging opgehaald worden, bepaalt dit id van welke vestiging
     * @return Success
     */
    klantprofiel_en_motivering_ophalen(vestigingId: string | null | undefined): Promise<KlantprofielMotiveringOutput> {
        let url_ = this.baseUrl + "/KlantprofielMotivering";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKlantprofiel_en_motivering_ophalen(_response);
        });
    }

    protected processKlantprofiel_en_motivering_ophalen(response: Response): Promise<KlantprofielMotiveringOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielMotiveringOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielMotiveringOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KlantprofielMotiveringOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KlantprofielMotiveringOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Klantprofiel en motivering
     * @param vestigingId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    klantprofiel_en_motivering_wijzigen(vestigingId: string | null | undefined, body: KlantprofielMotivering | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/KlantprofielMotivering";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKlantprofiel_en_motivering_wijzigen(_response);
        });
    }

    protected processKlantprofiel_en_motivering_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Voorkeuren/Lastenoverzicht
     * @param vestigingId (optional) Als de gegevens van een vestiging opgehaald worden, bepaalt dit id van welke vestiging
     * @return Success
     */
    lastenoverzicht_ophalen(vestigingId: string | null | undefined): Promise<LastenoverzichtOutput> {
        let url_ = this.baseUrl + "/Lastenoverzicht";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLastenoverzicht_ophalen(_response);
        });
    }

    protected processLastenoverzicht_ophalen(response: Response): Promise<LastenoverzichtOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenoverzichtOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenoverzichtOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastenoverzichtOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LastenoverzichtOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Voorkeuren/Lastenoverzicht
     * @param vestigingId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    lastenoverzicht_wijzigen(vestigingId: string | null | undefined, body: Lastenoverzicht | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Lastenoverzicht";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLastenoverzicht_wijzigen(_response);
        });
    }

    protected processLastenoverzicht_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Voorkeuren/Rapportage
     * @param vestigingId (optional) Als de gegevens van een vestiging opgehaald worden, bepaalt dit id van welke vestiging
     * @return Success
     */
    rapportage_ophalen(vestigingId: string | null | undefined): Promise<RapportageOutput> {
        let url_ = this.baseUrl + "/Rapportage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportage_ophalen(_response);
        });
    }

    protected processRapportage_ophalen(response: Response): Promise<RapportageOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportageOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportageOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RapportageOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RapportageOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Voorkeuren/Rapportage
     * @param vestigingId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    rapportage_wijzigen(vestigingId: string | null | undefined, body: Rapportage | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Rapportage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportage_wijzigen(_response);
        });
    }

    protected processRapportage_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Vult de voorkeuren voor rapportage aan met de rapportstructuur in het gegeven importbestand.
     * @param vestigingId (optional) 
     * @return Created
     */
    rapportage_voorkeuren_importeren(vestigingId: string | null | undefined, rapportStructuurImportBestand: FileParameter): Promise<void> {
        let url_ = this.baseUrl + "/Rapportage/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (rapportStructuurImportBestand === null || rapportStructuurImportBestand === undefined)
            throw new Error("The parameter 'rapportStructuurImportBestand' cannot be null.");
        else
            content_.append("rapportStructuurImportBestand", rapportStructuurImportBestand.data, rapportStructuurImportBestand.fileName ? rapportStructuurImportBestand.fileName : "rapportStructuurImportBestand");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportage_voorkeuren_importeren(_response);
        });
    }

    protected processRapportage_voorkeuren_importeren(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft het exportbestand terug behorende bij de rapportstructuur met de gegeven ID.
     * @param vestigingId (optional) 
     * @param structuurId (optional) Unieke ID van de rapport-structuur die geëxporteerd moet worden
     * @return Success
     */
    rapportstructuur_exporteren(vestigingId: string | null | undefined, structuurId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Rapportage/Export?";
        if (structuurId !== undefined && structuurId !== null)
            url_ += "structuurId=" + encodeURIComponent("" + structuurId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRapportstructuur_exporteren(_response);
        });
    }

    protected processRapportstructuur_exporteren(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Standaard teksten voor een motivering-onderwerp.
     * @param vestigingId (optional) De identificatie van de vestiging
     * @param onderwerpsoort Het soort motivering-onderwerp
     * @return Success
     */
    standaard_teksten_ophalen(vestigingId: string | null | undefined, onderwerpsoort: Onderwerpsoort): Promise<StandaardTekstenOutput> {
        let url_ = this.baseUrl + "/StandaardTeksten?";
        if (onderwerpsoort === undefined || onderwerpsoort === null)
            throw new Error("The parameter 'onderwerpsoort' must be defined and cannot be null.");
        else
            url_ += "onderwerpsoort=" + encodeURIComponent("" + onderwerpsoort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStandaard_teksten_ophalen(_response);
        });
    }

    protected processStandaard_teksten_ophalen(response: Response): Promise<StandaardTekstenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StandaardTekstenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StandaardTekstenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StandaardTekstenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandaardTekstenOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Standaard teksten voor een motivering-onderwerp.
     * @param vestigingId (optional) De identificatie van de vestiging
     * @param onderwerpsoort Het soort motivering-onderwerp
     * @param body (optional) De inhoud van het Adviesbox-form Standaard teksten
     * @return No Content
     */
    standaard_teksten_wijzigen(vestigingId: string | null | undefined, onderwerpsoort: Onderwerpsoort2, body: StandaardTeksten | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/StandaardTeksten?";
        if (onderwerpsoort === undefined || onderwerpsoort === null)
            throw new Error("The parameter 'onderwerpsoort' must be defined and cannot be null.");
        else
            url_ += "onderwerpsoort=" + encodeURIComponent("" + onderwerpsoort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStandaard_teksten_wijzigen(_response);
        });
    }

    protected processStandaard_teksten_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Importeert een standaardtekstenbestand en werkt hiermee de instellingen bij.
     * @param vestigingId De identificatie van de vestiging
     * @param overschrijven (optional) Indicatie of de bestaande standaardteksten overschreven (true) of aangevuld (false) moeten worden
     * @return Created
     */
    standaard_teksten_importeren(vestigingId: string, overschrijven: boolean | null | undefined, standaardTekstenImportBestand: FileParameter): Promise<void> {
        let url_ = this.baseUrl + "/StandaardTeksten/Import?";
        if (overschrijven !== undefined && overschrijven !== null)
            url_ += "overschrijven=" + encodeURIComponent("" + overschrijven) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (standaardTekstenImportBestand === null || standaardTekstenImportBestand === undefined)
            throw new Error("The parameter 'standaardTekstenImportBestand' cannot be null.");
        else
            content_.append("standaardTekstenImportBestand", standaardTekstenImportBestand.data, standaardTekstenImportBestand.fileName ? standaardTekstenImportBestand.fileName : "standaardTekstenImportBestand");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStandaard_teksten_importeren(_response);
        });
    }

    protected processStandaard_teksten_importeren(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Exporteert de ingestelde standaardteksten uit de instellingen
     * @param vestigingId De identificatie van de vestiging
     * @return Success
     */
    standaard_teksten_exporteren(vestigingId: string): Promise<void> {
        let url_ = this.baseUrl + "/StandaardTeksten/Export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStandaard_teksten_exporteren(_response);
        });
    }

    protected processStandaard_teksten_exporteren(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Voorkeuren/Tarieven
     * @param vestigingId (optional) Als de gegevens van een vestiging opgehaald worden, bepaalt dit id van welke vestiging
     * @return Success
     */
    tarieven_ophalen(vestigingId: string | null | undefined): Promise<TarievenOutput> {
        let url_ = this.baseUrl + "/Tarieven";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTarieven_ophalen(_response);
        });
    }

    protected processTarieven_ophalen(response: Response): Promise<TarievenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TarievenOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TarievenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TarievenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TarievenOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Voorkeuren/Tarieven
     * @param vestigingId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    tarieven_wijzigen(vestigingId: string | null | undefined, body: Tarieven | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Tarieven";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTarieven_wijzigen(_response);
        });
    }

    protected processTarieven_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de gegevens van Form Uitgangspunten Advies
     * @param vestigingId (optional) Als de gegevens van een vestiging opgehaald worden, bepaalt dit id van welke vestiging
     * @return Success
     */
    uitgangspuntenAdvies_ophalen(vestigingId: string | null | undefined): Promise<UitgangspuntenAdviesOutput> {
        let url_ = this.baseUrl + "/UitgangspuntenAdvies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUitgangspuntenAdvies_ophalen(_response);
        });
    }

    protected processUitgangspuntenAdvies_ophalen(response: Response): Promise<UitgangspuntenAdviesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UitgangspuntenAdviesOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UitgangspuntenAdviesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UitgangspuntenAdviesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UitgangspuntenAdviesOutput>(null as any);
    }

    /**
     * Verwerkt de gegevens van Form Uitgangspunten Advies
     * @param vestigingId (optional) 
     * @param body (optional) 
     * @return No Content
     */
    uitgangspuntenAdvies_wijzigen(vestigingId: string | null | undefined, body: UitgangspuntenAdvies | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/UitgangspuntenAdvies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "vestigingId": vestigingId !== undefined && vestigingId !== null ? "" + vestigingId : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUitgangspuntenAdvies_wijzigen(_response);
        });
    }

    protected processUitgangspuntenAdvies_wijzigen(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * @return Success
     */
    getFoutcodes(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFoutcodes(_response);
        });
    }

    protected processGetFoutcodes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

/** Output voor het opvragen of een specifiek onderdeel actief is */
export interface ActiefOutput {
    /** Veld om aan te geven of het onderdee; actief is */
    isActief: boolean;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Adres {
    straat: string | null;
    huisnummer: number | null;
    toevoeging: string | null;
    postcode: string | null;
    plaats: string | null;
    landCode: string | null;
}

/** Bevat de inhoud van het Adviesbox-form Adviesonderwerpen. */
export interface Adviesonderwerpen {
    /** Indicatie dat het onderwerp 'Hypotheek' getoond moet worden */
    onderwerpHypotheekTonen: boolean | null;
    /** Indicatie dat het onderwerp 'Overlijden' getoond moet worden */
    onderwerpOverlijdenTonen: boolean | null;
    /** Indicatie dat het onderwerp 'Arbeidsongeschiktheid' getoond moet worden */
    onderwerpArbeidsongeschiktheidTonen: boolean | null;
    /** Indicatie dat het onderwerp 'Werkloosheid' getoond moet worden */
    onderwerpWerkloosheidTonen: boolean | null;
    /** Indicatie dat het onderwerp 'Pensioen' getoond moet worden */
    onderwerpPensioenTonen: boolean | null;
    /** Indicatie dat het onderwerp 'Vermogensopbouw' getoond moet worden */
    onderwerpVermogensopbouwTonen: boolean | null;
    /** Indicatie dat het onderdeel 'Kapitaalverzekering' getoond moet worden */
    onderdeelKapitaalverzekeringTonen: boolean | null;
    /** Indicatie dat het onderdeel 'ORV' getoond moet worden */
    onderdeelOrvTonen: boolean | null;
    /** Indicatie dat het onderdeel 'AOV' getoond moet worden */
    onderdeelAovTonen: boolean | null;
    /** Indicatie dat het onderdeel 'Vermogen' getoond moet worden */
    onderdeelVermogenTonen: boolean | null;
    /** Indicatie dat het onderdeel 'Krediet' getoond moet worden */
    onderdeelKredietTonen: boolean | null;
    /** Indicatie dat het onderdeel 'Uitkerende lijfrente' getoond moet worden */
    onderdeelUitkerendeLijfrenteTonen: boolean | null;
    /** Indicatie dat het onderdeel 'Overig' getoond moet worden */
    onderdeelOverigTonen: boolean | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Adviesonderwerpen. */
export interface AdviesonderwerpenOutput {
    adviesonderwerpen: Adviesonderwerpen | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** AoScenarioOptions Standaard = 1, Extra1 = 2, Extra2 = 3 */
export enum AoScenarioOptions {
    Standaard = "Standaard",
    Extra1 = "Extra1",
    Extra2 = "Extra2",
}

/** Bevat de inhoud van het Adviesbox-form Autorisatieniveau. */
export interface Autorisatieniveau {
    algemeenNiveau: InstellingNiveauOptions;
    documentNiveau: InstellingNiveauOptions;
    tarievenNiveau: InstellingNiveauOptions;
    berekeningenNiveau: InstellingNiveauOptions;
    lastenoverzichtenNiveau: InstellingNiveauOptions;
    geldverstrekkersNiveau: InstellingNiveauOptions;
    verzekeraarsNiveau: InstellingNiveauOptions;
    vermogensbeheerdersNiveau: InstellingNiveauOptions;
    bankgarantieInstellingenNiveau: InstellingNiveauOptions;
    taxatiebureausNiveau: InstellingNiveauOptions;
    notarissenNiveau: InstellingNiveauOptions;
    serviceprovidersNiveau: InstellingNiveauOptions;
    klantprofielMotiveringNiveau: InstellingNiveauOptions;
    adviesonderwerpenNiveau: InstellingNiveauOptions;
    uitgangspuntenAdviesNiveau: InstellingNiveauOptions;
    standaardTekstenNiveau: InstellingNiveauOptions;
    generiekeKoppelingenNiveau: InstellingNiveauOptions;
    hdnNiveau: InstellingNiveauOptions;
    elementsNiveau: InstellingNiveauOptions;
    nationaleHypotheekbondNiveau: InstellingNiveauOptions;
    nationaleWaarborgNiveau: InstellingNiveauOptions;
    softwareKoppelingenNiveau: InstellingNiveauOptions;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Autorisatieniveau. */
export interface AutorisatieniveauOutput {
    autorisatieniveau: Autorisatieniveau | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface BadRequestResult {
    statusCode: number;
}

export interface BankgarantieinstellingPartij {
    code: string | null;
    partijnaam: string | null;
    actief: boolean;
    agentnummer: string | null;
}

export interface Bankgarantieinstellingen {
    partijen: BankgarantieinstellingPartij[] | null;
}

export interface BankgarantieinstellingenOutput {
    bankgarantieinstellingen: Bankgarantieinstellingen | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de inhoud van het Adviesbox-form Voorkeuren/Berekeningen. */
export interface Berekeningen {
    algemeen: BerekeningenAlgemeen;
    heffingskortingen: BerekeningenHeffingskortingen;
    scenarios: BerekeningenScenarios;
}

/** Bevat de inhoud van 'Algemeen'. */
export interface BerekeningenAlgemeen {
    /** Huurstijging per jaar */
    huurstijgingPercentage: number;
    /** Indexatie waarde pand per jaar */
    indexatieWaardePandPercentage: number;
    /** Mindering overwaarde op de gewenste hypotheek */
    minderingOverwaardeGewensteHypotheek: boolean;
}

/** Bevat de inhoud van 'Heffingskortingen'. */
export interface BerekeningenHeffingskortingen {
    /** Algemene heffingskorting */
    algemeneHeffingskorting: boolean;
    /** Arbeidskorting */
    arbeidskorting: boolean;
    /** Inkomensafhankelijke combinatiekorting */
    inkomensafhankelijkeCombinatiekorting: boolean;
    /** Ouderenkorting */
    ouderenkorting: boolean;
    /** Alleenstaande ouderenkorting */
    alleenstaandeOuderenkorting: boolean;
    /** Werkbonus */
    werkbonus: boolean;
    /** Kindgebonden budget */
    kindgebondenBudget: boolean;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Voorkeuren/Berekeningen. */
export interface BerekeningenOutput {
    berekeningen: Berekeningen | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de inhoud van 'Scenario's'. */
export interface BerekeningenScenarios {
    /** Ingangsdatum scenario's */
    ingangsdatumScenarios: string;
    /** Lengte van het overzicht in jaren */
    lengteOverzichtInJaren: number;
    /** Eindleeftijd scenario's */
    eindleeftijdScenarios: number;
    /** Rekenrente contante waarde */
    rekenrenteContanteWaardePercentage: number;
    controleNbi: ControleNbiOptions;
}

/** ControleGewenstInkomenOptions NettoBesteedbaarInkomen = 1, BrutoInkomenswens = 2, Geen = 3 */
export enum ControleGewenstInkomenOptions {
    NettoBesteedbaarInkomen = "NettoBesteedbaarInkomen",
    BrutoInkomenswens = "BrutoInkomenswens",
    Geen = "Geen",
}

/** ControleGewenstNbiOptions BehoudenHuidigNbi = 0, MargeHuidigNbi = 1, VastBedrag = 2, PercentageHuidigNbi = 3 */
export enum ControleGewenstNbiOptions {
    BehoudenHuidigNbi = "BehoudenHuidigNbi",
    MargeHuidigNbi = "MargeHuidigNbi",
    VastBedrag = "VastBedrag",
    PercentageHuidigNbi = "PercentageHuidigNbi",
}

/** ControleMaandlastOptions BenodigdInkomen = 1, WerkelijkeLast = 2 */
export enum ControleMaandlastOptions {
    BenodigdInkomen = "BenodigdInkomen",
    WerkelijkeLast = "WerkelijkeLast",
}

/** ControleNbiOptions HuidigeSituatie = 1, SituatieNaAdvies = 2 */
export enum ControleNbiOptions {
    HuidigeSituatie = "HuidigeSituatie",
    SituatieNaAdvies = "SituatieNaAdvies",
}

/** Bevat de inhoud van het Adviesbox-form Voorkeuren/Documenten. */
export interface Documenten {
    ondertekening: DocumentenOndertekening | null;
    voorbladVervolgpaginas: DocumentenVoorbladVervolgpaginas | null;
    overzichten: DocumentenOverzichten | null;
    lastenoverzichten: DocumentenLastenoverzichten | null;
    nbiOverzicht: DocumentenNbiOverzicht | null;
}

/** Bevat de inhoud van 'Kolommen in de lastenoverzichten'. */
export interface DocumentenLastenoverzichten {
    /** Bruto inkomen */
    brutoInkomen: boolean;
    /** Som hypotheken */
    somHypotheken: boolean;
    /** Waardeopbouw */
    waardeopbouw: boolean;
    /** Huur */
    huur: boolean;
    /** Rente */
    rente: boolean;
    /** Hypotheek aflossing */
    hypotheekAflossing: boolean;
    /** Uitkering kapitaalverzekeringen */
    uitkeringKapitaalverzekeringen: boolean;
    /** Verzekeringspremies */
    verzekeringspremies: boolean;
    /** Spaar- en beleggingsdepot */
    spaarEnBeleggingsdepot: boolean;
    /** Opname uit depot */
    opnameUitDepot: boolean;
    /** Krediet last */
    kredietlast: boolean;
    /** Overige uitgaven */
    overigeUitgaven: boolean;
    /** Bruto last */
    brutoLast: boolean;
    /** Fiscaal voordeel */
    fiscaalVoordeel: boolean;
    /** VRH */
    vrh: boolean;
    /** Netto last */
    nettoLast: boolean;
}

/** Bevat de inhoud van 'Kolommen in het netto besteedbaar inkomen overzicht'. */
export interface DocumentenNbiOverzicht {
    /** Hypotheek */
    hypotheek: boolean;
    /** Verzekeringen */
    verzekeringen: boolean;
    /** Spaar- en beleggingsdepots */
    spaarEnBeleggingsdepots: boolean;
    /** Krediet last */
    kredietLast: boolean;
    /** Overige uitgaven */
    overigUitgaven: boolean;
    /** Totale uitgaven */
    totaleUitgaven: boolean;
    /** Bruto inkomen */
    brutoInkomen: boolean;
    /** Inkomstenbelasting */
    inkomstenbelasting: boolean;
    /** VRH */
    vrh: boolean;
    /** Netto inkomsten */
    nettoInkomsten: boolean;
    /** Netto besteedbaar inkomen */
    nbi: boolean;
}

/** Bevat de inhoud van 'Ondertekening'. */
export interface DocumentenOndertekening {
    tonenOpFormulieren: TonenOpFormulierenOptions;
    weergaveAdviseurnaam: WeergaveAdviseurnaamOptions;
    /** Extra ondertekeningsregel */
    extraOndertekeningsregel: string | null;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Voorkeuren/Documenten. */
export interface DocumentenOutput {
    /** Id van de entiteit */
    entiteitId: string | null;
    documenten: Documenten | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de inhoud van 'Overzichten'. */
export interface DocumentenOverzichten {
    /** Bedrijfslogo tonen op overzichten */
    bedrijfslogoOverzichtenTonen: boolean;
    overzichtTonenVan: OverzichtTonenVanOptions;
    /** Toon grafieken bij scenario overzichten */
    toonGrafiekScenarioOverzicht: boolean;
}

/** Bevat de inhoud van 'Voorblad en vervolgpagina's'. */
export interface DocumentenVoorbladVervolgpaginas {
    /** Bedrijfslogo tonen op voorblad */
    bedrijfslogoVoorbladTonen: boolean;
    uitlijningBedrijfslogoVoorblad: UitlijningOptions | null;
    /** Bedrijfsgegevens tonen op voorblad */
    bedrijfsgegevensVoorbladTonen: boolean;
    uitlijningBedrijfsgegevensVoorblad: UitlijningOptions | null;
    /** Bedrijfslogo op vervolgpagina's tonen */
    bedrijfsgegevensVervolgpaginasTonen: boolean;
    uitlijningBedrijfslogoVervolgpaginas: UitlijningOptions | null;
}

/** DuurOverzichtOptions TotLeeftijd = 1, VasteDuurInJaren = 2, Levenslang = 3 */
export enum DuurOverzichtOptions {
    TotLeeftijd = "TotLeeftijd",
    VasteDuurInJaren = "VasteDuurInJaren",
    Levenslang = "Levenslang",
}

/** Bevat de velden voor het instellen van de koppeling met Elements. */
export interface Elements {
    /** URL van het portaal van Elements */
    locatiePortaalUrl: string | null;
    /** Organisatienummer */
    organisatienummer: string | null;
    /** Gebruikersnaam voor de API van Elements */
    gebruikersnaamApi: string | null;
    /** Wachtwoord voor de API van Elements */
    wachtwoordApi: string | null;
}

/** Output voor het instellen van de koppeling met Elements. */
export interface ElementsOutput {
    elements: Elements | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface GeldverstrekkerPartij {
    serviceproviderId: string | null;
    softwareKoppelingId: string | null;
    aanvullendeRetourwijze: number | null;
    hypotheeklabels: Hypotheeklabel[] | null;
    code: string | null;
    partijnaam: string | null;
    actief: boolean;
    agentnummer: string | null;
}

export interface Geldverstrekkers {
    partijen: GeldverstrekkerPartij[] | null;
    serviceproviders: ServiceproviderReadOnly[] | null;
    softwareKoppelingen: SoftwareKoppelingReadOnly[] | null;
}

export interface GeldverstrekkersOutput {
    geldverstrekkers: Geldverstrekkers | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** GeslachtOpties Geen = 0, Man = 1, Vrouw = 2 */
export enum GeslachtOpties {
    Geen = "Geen",
    Man = "Man",
    Vrouw = "Vrouw",
}

export interface Hypotheeklabel {
    code: number;
    readonly omschrijving: string | null;
    hypotheekopties: Hypotheekoptie[] | null;
}

export interface Hypotheekoptie {
    code: number;
    readonly omschrijving: string | null;
    readonly toelichting: string | null;
    geselecteerd: boolean;
    readonly optieGroep: number | null;
}

/** Bevat de velden voor het instellen van een importkoppeling. */
export interface Importkoppeling {
    /** Koppeling key */
    koppelingKey: string | null;
    /** Naam van de importkoppeling */
    readonly koppelingNaam: string | null;
}

/** Output voor het instellen van een importkoppeling. */
export interface ImportkoppelingOutput {
    importkoppeling: Importkoppeling | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Output voor het instellen van een importkoppeling. */
export interface ImportkoppelingenOutput {
    /** De velden voor het instellen van de importkoppeling */
    importkoppelingen: Importkoppeling[] | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** InstellingNiveauOptions Organisatie = 1, Vestiging = 2, Medewerker = 3 */
export enum InstellingNiveauOptions {
    Organisatie = "Organisatie",
    Vestiging = "Vestiging",
    Medewerker = "Medewerker",
}

/** Bevat de inhoud van het Adviesbox-form Klantprofiel en motivering. */
export interface KlantprofielMotivering {
    soortControleVolledigheid: SoortControleVolledigheidOptions;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Klantprofiel en motivering. */
export interface KlantprofielMotiveringOutput {
    klantprofielMotivering: KlantprofielMotivering | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de inhoud van het Adviesbox-form Voorkeuren/Lastenoverzicht. */
export interface Lastenoverzicht {
    meenemenInLastenoverzicht: LastenoverzichtMeenemen | null;
    verrekenenInLasten: LastenoverzichtVerrekenen | null;
}

/** Bevat de inhoud van 'Meenemen in lastenoverzicht'. */
export interface LastenoverzichtMeenemen {
    /** Kredietlasten */
    kredietlasten: boolean;
    /** Erfpacht */
    erfpacht: boolean;
    /** Servicekosten */
    servicekosten: boolean;
    /** Financieringskosten */
    financieringskosten: boolean;
    /** Boeterente */
    boeterente: boolean;
    /** Gespreide betaling advieskosten en bemiddelingsvergoeding */
    gespreideBetaling: boolean;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Voorkeuren/Lastenoverzicht. */
export interface LastenoverzichtOutput {
    lastenoverzicht: Lastenoverzicht | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de inhoud van 'Verrekenen in lasten'. */
export interface LastenoverzichtVerrekenen {
    /** Uitkeringen uit financiële dekkingen */
    uitkeringenFinancieleDekkingen: boolean;
    /** Aflossingen hypotheek (niet zijnde: annuïtair en lineair) */
    aflossingenHypotheek: boolean;
    /** Aanvangsstortingen / eerste inleg */
    aanvangsstortingen: boolean;
    /** Extra stortingen */
    extraStortingen: boolean;
    /** Onttrekkingen */
    onttrekkingen: boolean;
    /** Extra opnames */
    extraOpnames: boolean;
    /** 1e jaar alleen nieuwe situatie tonen */
    jaar1AlleenNieuweSituatie: boolean;
}

/** MotiveringOnderwerpsoort Geen = 0, Algemeen = 1, Rentevastperiode = 2, FiscaleAftrek = 3, InbrengEigenGeld = 4, OversluitenHypotheek = 5, VerantwoordeWoonlasten = 6, Box3Consumptief = 7, AfdekkenOverlijdensrisico = 8, AfdekkenAOWW = 9, Pensioenvoorziening = 10, HoogteOpbouwDoelvermogen = 11, WijzeOpbouwDoelvermogen = 12, Beleggingsproduct = 13, Beleggingsprofiel = 14, Fondskeuze = 15, OversluitenBeleggingspolis = 16, AfdekkenWW = 17, Kredieten = 18, DubbeleWoonlasten = 19, EerderStoppen = 20, Geldverstrekker = 21, HypotheekAflossen = 22, Schade = 23, Risicoprofiel = 24, Nazorg = 25, Energie = 26, Telecom = 27, Uitvaart = 28, Verduurzaming = 29, Alles = -1 */
export enum MotiveringOnderwerpsoort {
    Geen = "Geen",
    Algemeen = "Algemeen",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    OversluitenHypotheek = "OversluitenHypotheek",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Box3Consumptief = "Box3Consumptief",
    AfdekkenOverlijdensrisico = "AfdekkenOverlijdensrisico",
    AfdekkenAOWW = "AfdekkenAOWW",
    Pensioenvoorziening = "Pensioenvoorziening",
    HoogteOpbouwDoelvermogen = "HoogteOpbouwDoelvermogen",
    WijzeOpbouwDoelvermogen = "WijzeOpbouwDoelvermogen",
    Beleggingsproduct = "Beleggingsproduct",
    Beleggingsprofiel = "Beleggingsprofiel",
    Fondskeuze = "Fondskeuze",
    OversluitenBeleggingspolis = "OversluitenBeleggingspolis",
    AfdekkenWW = "AfdekkenWW",
    Kredieten = "Kredieten",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    EerderStoppen = "EerderStoppen",
    Geldverstrekker = "Geldverstrekker",
    HypotheekAflossen = "HypotheekAflossen",
    Schade = "Schade",
    Risicoprofiel = "Risicoprofiel",
    Nazorg = "Nazorg",
    Energie = "Energie",
    Telecom = "Telecom",
    Uitvaart = "Uitvaart",
    Verduurzaming = "Verduurzaming",
    Alles = "Alles",
}

export interface NotarisPersoon {
    achternaam: string | null;
    voorvoegsel: string | null;
    voorletters: string | null;
    geslacht: GeslachtOpties;
}

export interface Notariskantoor {
    notariskantoorId: string | null;
    kantoornaam: string;
    adres: Adres | null;
    contactpersoon: NotarisPersoon | null;
    telefoonnummer: string | null;
}

export interface Notarissen {
    partijen: Notariskantoor[] | null;
}

export interface NotarissenOutput {
    notarissen: Notarissen | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** OverzichtTonenVanOptions AlleJaren = 1, AllenJarenMetWijzigingen = 2 */
export enum OverzichtTonenVanOptions {
    AlleJaren = "AlleJaren",
    AllenJarenMetWijzigingen = "AllenJarenMetWijzigingen",
}

export interface Rapportage {
    structuren: RapportageStructuur[];
}

export interface RapportageElement {
    code: number;
    naam: string | null;
    geselecteerd: boolean;
    soortElement: SoortElementOptions;
    volgnummer: number;
    elementen: RapportageElement[] | null;
}

export interface RapportageKolommenLasten {
    brutoInkomen: boolean;
    somHypotheken: boolean;
    waardeopbouw: boolean;
    huur: boolean;
    rente: boolean;
    hypotheekAflossing: boolean;
    uitkeringKapitaalverzekering: boolean;
    verzekeringspremies: boolean;
    spaarBeleggingsdepots: boolean;
    opnameUitDepot: boolean;
    kredietLast: boolean;
    overigeUitgaven: boolean;
    brutoLast: boolean;
    fiscaalVoordeel: boolean;
    vrh: boolean;
    nettoLast: boolean;
}

export interface RapportageKolommenNbi {
    hypotheek: boolean;
    verzekeringen: boolean;
    spaarBeleggingsdepots: boolean;
    kredietLast: boolean;
    overigeUitgaven: boolean;
    brutoLast: boolean;
    inkomstenbelasting: boolean;
    vrh: boolean;
    nettoInkomen: boolean;
    nbi: boolean;
}

export interface RapportageKolomselectie {
    kolommenLasten: RapportageKolommenLasten;
    kolommenNbi: RapportageKolommenNbi;
}

export interface RapportageOutput {
    rapportage: Rapportage | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface RapportageStructuur {
    structuurId: string | null;
    naam: string;
    volgnummer: number;
    standaardRapport: StandaardRapportOptions | null;
    kolomselectie: RapportageKolomselectie;
    elementen: RapportageElement[];
}

export interface Serviceprovider {
    serviceproviderId: string | null;
    wijzigbaar: boolean;
    naam: string;
    actief: boolean;
    hdnNummer: string | null;
}

export interface ServiceproviderReadOnly {
    serviceproviderId: string;
    readonly naam: string | null;
    readonly hdnNummer: string | null;
}

export interface Serviceproviders {
    partijen: Serviceprovider[] | null;
}

export interface ServiceprovidersOutput {
    serviceproviders: Serviceproviders | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface SoftwareKoppeling {
    softwareKoppelingId: string | null;
    wijzigbaar: boolean;
    naam: string;
    actief: boolean;
    hdnNummer: string | null;
    isImportkoppeling: boolean;
}

export interface SoftwareKoppelingReadOnly {
    softwareKoppelingId: string;
    readonly naam: string | null;
}

export interface SoftwareKoppelingen {
    partijen: SoftwareKoppeling[] | null;
}

export interface SoftwareKoppelingenOutput {
    softwareKoppelingen: SoftwareKoppelingen | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** SoortControleVolledigheidOptions GeenControle = 1, AlleenKlantprofiel = 2, KlantprofielEnMotivering = 3 */
export enum SoortControleVolledigheidOptions {
    GeenControle = "GeenControle",
    AlleenKlantprofiel = "AlleenKlantprofiel",
    KlantprofielEnMotivering = "KlantprofielEnMotivering",
}

/** SoortElementOptions Onderdeel = 1, Hoofdstuk = 2, Koptekst = 3, Tekstblok = 4, Grafiek = 5, Tabel = 6 */
export enum SoortElementOptions {
    Onderdeel = "Onderdeel",
    Hoofdstuk = "Hoofdstuk",
    Koptekst = "Koptekst",
    Tekstblok = "Tekstblok",
    Grafiek = "Grafiek",
    Tabel = "Tabel",
}

/** StandaardRapportOptions VolledigFinancieelPlan = 1, KortRapport = 2, Inventarisatierapport = 3 */
export enum StandaardRapportOptions {
    VolledigFinancieelPlan = "VolledigFinancieelPlan",
    KortRapport = "KortRapport",
    Inventarisatierapport = "Inventarisatierapport",
}

export interface StandaardTekst {
    standaardtekstVoor: StandaardtekstVoorOptions;
    korteOmschrijving: string | null;
    tekst: string | null;
}

export interface StandaardTeksten {
    standaardTekstenMotiveringOnderwerp: StandaardTekst[];
}

export interface StandaardTekstenOutput {
    standaardTeksten: StandaardTeksten | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** StandaardtekstVoorOptions OnsAdvies = 1, AfwijkendeKeuze = 2 */
export enum StandaardtekstVoorOptions {
    OnsAdvies = "OnsAdvies",
    AfwijkendeKeuze = "AfwijkendeKeuze",
}

/** Gegevens van de tarieven */
export interface Tarieven {
    leveringsakteVaststellingWaarde: VastBedragOptions;
    /** Vast bedrag voor 'Leveringsakte' */
    leveringsakteVastBedrag: number | null;
    hypotheekakteVaststellingWaarde: VastBedragOptions;
    /** Vast bedrag voor 'Hypotheekakte' */
    hypotheekakteVastBedrag: number | null;
    taxatiekostenVaststellingWaarde: VastBedragOptions;
    /** Vast bedrag voor 'Taxatiekosten' */
    taxatiekostenVastBedrag: number | null;
    hypothecaireInschrijvingVaststellingWaarde: VastBedragPercentageOptions;
    /** Vast bedrag voor 'Hypothecaire inschrijving' */
    hypothecaireInschrijvingVastBedrag: number | null;
    /** Percentage voor 'Hypothecaire inschrijving' */
    hypothecaireInschrijvingPercentage: number | null;
    hypotheekAdvieskostenVaststellingWaarde: VastBedragBedragPerUurOptions;
    /** Vast bedrag voor 'Advieskosten' (met hypotheekadvies) */
    hypotheekAdvieskostenVastBedrag: number | null;
    /** Bedrag per uur voor 'Advieskosten' (met hypotheekadvies) */
    hypotheekAdvieskostenBedragPerUur: number | null;
    bemiddelingsvergoedingGeldleningVaststellingWaarde: VastBedragBedragPerUurOptions;
    /** Vast bedrag voor 'Bemiddelingsvergoeding geldlening' */
    bemiddelingsvergoedingGeldleningVastBedrag: number | null;
    /** Bedrag per uur voor 'Bemiddelingsvergoeding geldlening' */
    bemiddelingsvergoedingGeldleningBedragPerUur: number | null;
    overigeBemiddelingsvergoedingVaststellingWaarde: VastBedragBedragPerUurOptions;
    /** Vast bedrag voor 'Overige bemiddelingsvergoeding' */
    overigeBemiddelingsvergoedingVastBedrag: number | null;
    /** Bedrag per uur voor 'Overige bemiddelingsvergoeding' */
    overigeBemiddelingsvergoedingBedragPerUur: number | null;
    /** Vast bedrag voor 'Dossiervergoeding' */
    dossiervergoedingVastBedrag: number | null;
    advieskostenVaststellingWaarde: VastBedragBedragPerUurOptions;
    /** Vast bedrag voor 'Advieskosten' (zonder hypotheekadvies) */
    advieskostenVastBedrag: number | null;
    /** Bedrag per uur voor 'Advieskosten' (zonder hypotheekadvies) */
    advieskostenBedragPerUur: number | null;
    bemiddelingsvergoedingVaststellingWaarde: VastBedragBedragPerUurOptions;
    /** Vast bedrag voor 'Bemiddelingsvergoeding' (zonder hypotheekadvies) */
    bemiddelingsvergoedingVastBedrag: number | null;
    /** Bedrag per uur voor 'Bemiddelingsvergoeding' (zonder hypotheekadvies) */
    bemiddelingsvergoedingBedragPerUur: number | null;
}

/** Outputmodel voor het opvragen van de gegevens van Tarieven. */
export interface TarievenOutput {
    tarieven: Tarieven | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface TaxatiebureauPartij {
    code: string | null;
    partijnaam: string | null;
    actief: boolean;
    agentnummer: string | null;
}

export interface Taxatiebureaus {
    partijen: TaxatiebureauPartij[] | null;
}

export interface TaxatiebureausOutput {
    taxatiebureaus: Taxatiebureaus | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Output voor het opvragen van de token voor de communicatie met een externe partij */
export interface TokenOutput {
    tokens: Tokens | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de velden voor het onderhouden van een token voor de communicatie met een externe partij. */
export interface Tokens {
    /** Token voor het communiceren met een externe partij. */
    token: string | null;
}

/** TonenOpFormulierenOptions AdviseurnaamVanHoofdkantoor = 1, AdviseurnaamVanBijkantoor = 2 */
export enum TonenOpFormulierenOptions {
    AdviseurnaamVanHoofdkantoor = "AdviseurnaamVanHoofdkantoor",
    AdviseurnaamVanBijkantoor = "AdviseurnaamVanBijkantoor",
}

/** Bevat de inhoud van het Adviesbox-form Uitgangspunten Advies. */
export interface UitgangspuntenAdvies {
    /** Geeft aan of een call vanaf Instellingenscherm of Scenario komt */
    instellingenScherm: boolean;
    werkloosheid: UitgangspuntenAdviesWerkloosheid;
    pensioen: UitgangspuntenAdviesPensioen;
    overlijden: UitgangspuntenAdviesOverlijden;
    arbeidongeschiktheid: UitgangspuntenAdviesArbeidongeschiktheid;
}

/** Bevat de inhoud van een scenario t.b.v. 'Arbeidongeschiktheid'. */
export interface UitgangspuntenAdviesAoScenario {
    scenario: AoScenarioOptions;
    /** AO percentage */
    aoPercentage: number;
    /** Duurzaam AO */
    duurzaamAo: boolean | null;
    /** Benutting verdiencapaciteit */
    verdiencapaciteitPercentage: number;
}

/** Bevat de inhoud van 'Arbeidongeschiktheid'. */
export interface UitgangspuntenAdviesArbeidongeschiktheid {
    /** Toetsjaar tekort */
    toetsjaarTekort: number;
    /** De AO-scenario's */
    scenarios: UitgangspuntenAdviesAoScenario[];
    controleHypotheeknorm: UitgangspuntenAdviesControleHypotheeknorm;
    controleGewenstInkomen: UitgangspuntenAdviesControleGewenstInkomen;
}

/** Bevat de uitgangspunten voor de controle op gewenst inkomen. */
export interface UitgangspuntenAdviesControleGewenstInkomen {
    controleOpGewenstInkomen: ControleGewenstInkomenOptions;
    controleGewenstNbi: ControleGewenstNbiOptions | null;
    /** Ondergrens van 'Acceptabele marge op huidig NBI' */
    margeOndergrensPercentage: number | null;
    /** Bovengrens van 'Acceptabele marge op huidig NBI' */
    margeBovengrensPercentage: number | null;
    /** Bedrag bij 'Overhouden van vast bedrag NBI' */
    vastBedrag: number | null;
    /** Percentage van huidig NBI */
    huidigNbiPercentage: number | null;
    /** Indicatie dat de tabel 'Gewijzigde jaren' getoond moet worden */
    gewijzigdeJarenTonen: boolean | null;
    /** Indicatie dat de tabel 'Benodigd kapitaal' getoond moet worden */
    benodigdKapitaalTonen: boolean | null;
}

/** Bevat de uitgangspunten voor de controle op hypotheeknorm. */
export interface UitgangspuntenAdviesControleHypotheeknorm {
    controleMaandlast: ControleMaandlastOptions | null;
    /** Indicatie dat op de maximale hypotheeksom gecontroleerd moet worden */
    controleerMaximaleHypotheek: boolean;
}

/** Output voor het opvragen van de inhoud van het Adviesbox-form Uitgangspunten Advies. */
export interface UitgangspuntenAdviesOutput {
    uitgangspuntenAdvies: UitgangspuntenAdvies | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de inhoud van 'Overlijden'. */
export interface UitgangspuntenAdviesOverlijden {
    duurOverzicht: DuurOverzichtOptions;
    /** De duur van het overzicht bij keuze voor 'VasteDuurInJaren' */
    overzichtDuurInJaren: number | null;
    /** De leeftijd tot waar het overzicht moet lopen bij keuze voor 'TotLeeftijd' */
    overzichtTotLeeftijdInMaanden: number | null;
    controleHypotheeknorm: UitgangspuntenAdviesControleHypotheeknorm;
    controleGewenstInkomen: UitgangspuntenAdviesControleGewenstInkomen;
}

/** Bevat de inhoud van 'Pensioen'. */
export interface UitgangspuntenAdviesPensioen {
    controleHypotheeknorm: UitgangspuntenAdviesControleHypotheeknorm;
    controleGewenstInkomen: UitgangspuntenAdviesControleGewenstInkomen;
}

/** Bevat de inhoud van 'Werkloosheid'. */
export interface UitgangspuntenAdviesWerkloosheid {
    controleHypotheeknorm: UitgangspuntenAdviesControleHypotheeknorm;
    controleGewenstInkomen: UitgangspuntenAdviesControleGewenstInkomen;
}

/** UitlijningOptions Links = 1, Rechts = 2, Midden = 3 */
export enum UitlijningOptions {
    Links = "Links",
    Rechts = "Rechts",
    Midden = "Midden",
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface ValidationResultsModel {
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** VastBedragBedragPerUurOptions IndicatieveWaarde = 1, VastBedrag = 2, BedragPerUur = 3 */
export enum VastBedragBedragPerUurOptions {
    IndicatieveWaarde = "IndicatieveWaarde",
    VastBedrag = "VastBedrag",
    BedragPerUur = "BedragPerUur",
}

/** VastBedragOptions IndicatieveWaarde = 1, VastBedrag = 2 */
export enum VastBedragOptions {
    IndicatieveWaarde = "IndicatieveWaarde",
    VastBedrag = "VastBedrag",
}

/** VastBedragPercentageOptions IndicatieveWaarde = 1, VastBedrag = 2, Percentage = 4 */
export enum VastBedragPercentageOptions {
    IndicatieveWaarde = "IndicatieveWaarde",
    VastBedrag = "VastBedrag",
    Percentage = "Percentage",
}

export interface VermogensbeheerderPartij {
    code: string | null;
    partijnaam: string | null;
    actief: boolean;
    agentnummer: string | null;
}

export interface Vermogensbeheerders {
    partijen: VermogensbeheerderPartij[] | null;
}

export interface VermogensbeheerdersOutput {
    vermogensbeheerders: Vermogensbeheerders | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export interface VerzekeraarPartij {
    serviceproviderId: string | null;
    softwareKoppelingId: string | null;
    code: string | null;
    partijnaam: string | null;
    actief: boolean;
    agentnummer: string | null;
}

export interface Verzekeraars {
    partijen: VerzekeraarPartij[] | null;
    serviceproviders: ServiceproviderReadOnly[] | null;
    softwareKoppelingen: SoftwareKoppelingReadOnly[] | null;
}

export interface VerzekeraarsOutput {
    verzekeraars: Verzekeraars | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de gegevens van een voorblad-afbeelding. */
export interface VoorbladAfbeelding {
    /** Tijdelijke URL van de afbeelding */
    url: string | null;
}

/** Output voor het opvragen van een voorblad-afbeeling. */
export interface VoorbladAfbeeldingOutput {
    voorbladAfbeelding: VoorbladAfbeelding | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** WeergaveAdviseurnaamOptions VoorlettersAchternaam = 1, TitelAchternaam = 2, TitelVoorlettersAchternaam = 3, VoorlettersVoornamenAchternaam = 4, VoornamenAchternaam = 5 */
export enum WeergaveAdviseurnaamOptions {
    VoorlettersAchternaam = "VoorlettersAchternaam",
    TitelAchternaam = "TitelAchternaam",
    TitelVoorlettersAchternaam = "TitelVoorlettersAchternaam",
    VoorlettersVoornamenAchternaam = "VoorlettersVoornamenAchternaam",
    VoornamenAchternaam = "VoornamenAchternaam",
}

/** Het soort motivering-onderwerp */
export enum Onderwerpsoort {
    Geen = "Geen",
    Algemeen = "Algemeen",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    OversluitenHypotheek = "OversluitenHypotheek",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Box3Consumptief = "Box3Consumptief",
    AfdekkenOverlijdensrisico = "AfdekkenOverlijdensrisico",
    AfdekkenAOWW = "AfdekkenAOWW",
    Pensioenvoorziening = "Pensioenvoorziening",
    HoogteOpbouwDoelvermogen = "HoogteOpbouwDoelvermogen",
    WijzeOpbouwDoelvermogen = "WijzeOpbouwDoelvermogen",
    Beleggingsproduct = "Beleggingsproduct",
    Beleggingsprofiel = "Beleggingsprofiel",
    Fondskeuze = "Fondskeuze",
    OversluitenBeleggingspolis = "OversluitenBeleggingspolis",
    AfdekkenWW = "AfdekkenWW",
    Kredieten = "Kredieten",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    EerderStoppen = "EerderStoppen",
    Geldverstrekker = "Geldverstrekker",
    HypotheekAflossen = "HypotheekAflossen",
    Schade = "Schade",
    Risicoprofiel = "Risicoprofiel",
    Nazorg = "Nazorg",
    Energie = "Energie",
    Telecom = "Telecom",
    Uitvaart = "Uitvaart",
    Verduurzaming = "Verduurzaming",
    Alles = "Alles",
}

/** Het soort motivering-onderwerp */
export enum Onderwerpsoort2 {
    Geen = "Geen",
    Algemeen = "Algemeen",
    Rentevastperiode = "Rentevastperiode",
    FiscaleAftrek = "FiscaleAftrek",
    InbrengEigenGeld = "InbrengEigenGeld",
    OversluitenHypotheek = "OversluitenHypotheek",
    VerantwoordeWoonlasten = "VerantwoordeWoonlasten",
    Box3Consumptief = "Box3Consumptief",
    AfdekkenOverlijdensrisico = "AfdekkenOverlijdensrisico",
    AfdekkenAOWW = "AfdekkenAOWW",
    Pensioenvoorziening = "Pensioenvoorziening",
    HoogteOpbouwDoelvermogen = "HoogteOpbouwDoelvermogen",
    WijzeOpbouwDoelvermogen = "WijzeOpbouwDoelvermogen",
    Beleggingsproduct = "Beleggingsproduct",
    Beleggingsprofiel = "Beleggingsprofiel",
    Fondskeuze = "Fondskeuze",
    OversluitenBeleggingspolis = "OversluitenBeleggingspolis",
    AfdekkenWW = "AfdekkenWW",
    Kredieten = "Kredieten",
    DubbeleWoonlasten = "DubbeleWoonlasten",
    EerderStoppen = "EerderStoppen",
    Geldverstrekker = "Geldverstrekker",
    HypotheekAflossen = "HypotheekAflossen",
    Schade = "Schade",
    Risicoprofiel = "Risicoprofiel",
    Nazorg = "Nazorg",
    Energie = "Energie",
    Telecom = "Telecom",
    Uitvaart = "Uitvaart",
    Verduurzaming = "Verduurzaming",
    Alles = "Alles",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}